<template>
  <div class="flex p-1.5 rounded-full bg-grey-light-50 border border-grey-light-200 w-fit mt-2">
    <div
      v-for="product in products"
      :key="product.name"
      @click="switchProduct(product.name)"
      :class="[
        'flex items-center justify-center rounded-full py-2 px-6 cursor-pointer',
        shopsStore.currentProduct === product.name
          ? product.name === 'boost'
            ? 'bg-[#23D59F] shadow-sm'
            : 'bg-brand-600 shadow-sm'
          : '',
      ]"
    >
      <div class="h-[30px] flex items-center justify-center">
        <img
          :class="product.name === 'boost' ? 'h-[20px] w-20' : 'mt-1'"
          :src="shopsStore.currentProduct === product.name ? product.logoWhite : product.logoGrey"
          :alt="product.alt"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import boostGrey from '@/assets/shopper/boost-logo-grey.svg';
import boostWhite from '@/assets/shopper/boost-logo-white.svg';
import laybyGrey from '@/assets/shopper/layby-logo-grey.svg';
import laybyWhite from '@/assets/shopper/layby-logo-white.svg';
import { useShopsStore } from '@/stores/shops';

const shopsStore = useShopsStore();

const products = [
  { name: 'layby' as const, logoWhite: laybyWhite, logoGrey: laybyGrey, alt: 'LayUp Logo' },
  { name: 'boost' as const, logoWhite: boostWhite, logoGrey: boostGrey, alt: 'Boost Logo' },
];

const switchProduct = (product: 'layby' | 'boost') => {
  shopsStore.clearFilters();
  shopsStore.currentProduct = product;
};
</script>
